<template>
  <ul
    v-show="list && list.length"
    class="ten-file-list"
  >
    <slot>
      <ten-file-list-item
        v-for="(item, i) in list"
        v-bind="item"
        :key="item.key || i"
        :file="item"
        @file-list-item:remove="onItemRemove(item, i)"
        @file-list-item:preview="onItemPreview(item, i)"
      />
    </slot>
  </ul>
</template>

<script>
import TenFileListItem from './file-item';

const name = 'ten-file-list';

export default {
  name,
  components: {
    TenFileListItem,
  },
  props: {
    list: Array,
  },
  methods: {
    onItemRemove(item, i) {
      this.$emit('remove', item, i);
    },
    onItemPreview(item, i) {
      this.$emit('preview', item, i);
    },
  },
};
</script>
